import styled from "@emotion/styled";
import { Box, createTheme, Grid, Typography } from "@mui/material";

  export const colortheme = createTheme({
    palette: {
      primary: {
        main: '#292739',
      },
    },
    typography: {
      fontFamily: ['lato'].join(','),
    },
  });
  
  export const Body = styled(Grid)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    padding: '4rem',
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderRadius: '20px',
    gap: '6px',
  }));
  
  export const ContentGrid = styled(Grid)(({ theme }) => ({
    paddingLeft: '44px',
    paddingRight: '44px',
    display: 'flex',
    gap: '6px',
  }));
  
  export const EditLayer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
    gap: '3px',
    color: '#ddb930',
  }));
  
  export const TitleText = styled(Typography)(({ theme }) => ({
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#ffffff',
    paddingRight: '10px',
  }));
  
  export const EditText = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    color: '#ddb930',
  }));